import React, { Suspense } from "react";
import { Link } from "react-router-dom";
// const Status = React.lazy(() => import('./Status'));
import Switch from "@material-ui/core/Switch";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';

class Header extends React.Component {
    render() {
        return (
            <div>
                <div className="footer-left">
                    <div
                        className="footer-mute"
                        onClick={this.props.handleMute}
                    >
                        {this.props.volume === 0 ? "Unmute" : "Mute"}
                    </div>
                    <div className="chat-status">
                        <Link className="" to="/profile">
                            Profile
                        </Link>
                        <a className="" onClick={this.props.logOut}>
                            Exit
                        </a>
                        {this.props.user && ( 
                            <div className="chat-status-profile">
                                <span> {this.props.user.displayName}</span>
                                <img src={this.props.user.photoURL} />
                            </div>
                        )}
                    </div>
                    <div
                        className="chat-togle"

                    >
                                <IOSSwitch
                                    checked={this.props.chat}
                                    onChange={this.props.handleChatToggle}
                                    name="checkedB"
                                />

                        Chat
                    </div>
                </div>
            </div>
        );
    }
}

const IOSSwitch = withStyles((theme) => ({
    root: {
        width: '3.9em',
        height: '1.87em',
        padding: 0,
        margin: '0',
        marginRight: '0.5em',
    },
    switchBase: {
        padding: 1,
        opacity: 0.5,
        "&$checked": {
            transform: "translateX(1.7em)",
            color: theme.palette.common.white,
            opacity: 1,
            "& + $track": {
                backgroundColor: "red",
                opacity: 1,
                border: "none",
            },
        },
        "&$focusVisible $thumb": {
            color: "#52d869",
            border: "6px solid #fff",
        },
    },
    thumb: {
        width: '1.5em',
        height: '1.5em',
    },
    track: {
        borderRadius: '5em',
        border: `0px solid ${theme.palette.grey[400]}`,
        boxShadow: 'inset 0px 0px 10px rgba(255,255,255,0.5)',
        backgroundColor: 'rgba(255,255,255,0.1)',
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"]),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default Header;
